export const unitIds = {
    imperial: 'imperial',
    metric: 'metric',
};



// WEBPACK FOOTER //
// ./src/lib/localization/unitIds.js